module.exports = __webpack_public_path__ + "images/sprinboard.jpg";